import { Component, OnInit } from '@angular/core';
import { HttpService } from '../../http.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-front-partnership-form',
  templateUrl: './front-partnership-form.component.html',
  styleUrls: ['./front-partnership-form.component.scss']
})
export class FrontPartnershipFormComponent implements OnInit {

  public data: any = { status: 1 };

  constructor(private http: HttpService, private activatedRoute: ActivatedRoute) {
    this.activatedRoute.params.subscribe(params => {
      if (params['partnership_uuid']) {
        this.init(params['partnership_uuid']);
      }
    });
  }

  ngOnInit(): void {}

  async init(partnership_uuid: string) {
    this.data = await this.http.post('/admin/app/partnership/get', { partnership_uuid });
  }

  upload(data: any, key: string, single = false) {
    this.data[key] = single ? data[0] : data;
  }

  delete(data: any, key: string) {
    this.data[key] = data;
  }

  async submit() {
    if (!this.data.name || !this.data.link) {
      return;
    }
    const t = await this.http.post('/admin/app/partnership/save', this.data);
    if (t['status']) {
      this.http.notify('Partnership updated successfully.');
      this.http.naviBack();
    }
  }
}
